import { useQuery } from "@tanstack/react-query";
import { api } from "./api.ts";

/* ──────────────────────────────────────────────────────────────────────────
   People by their names (Jay, 2026-10-08: "jayxoga is Jay, adminoga is Ben,
   and use the name instead of the username").

   Older history across Signet recorded usernames: Links' activity and
   revisions, Swaps' submitted and decided by, onboarding ticks, flow saves.
   Rather than rewrite any of it, pages pass whatever was recorded through
   usePersonName(), which answers with the person's name when they have one
   and with what it was given otherwise.
   ────────────────────────────────────────────────────────────────────────── */

export function usePersonName(): (who: string | null | undefined) => string {
  const names = useQuery({
    queryKey: ["signet", "names"],
    queryFn: () => api<{ names: Record<string, string> }>("/api/me/names"),
    staleTime: 5 * 60_000,
    retry: false,
  });
  const map = names.data?.names ?? {};
  return (who) => {
    const raw = (who ?? "").trim();
    return map[raw.toLowerCase()] ?? raw;
  };
}

/** A recorded username (or name) shown as the person's name. */
export function PersonName({ who }: { who: string | null | undefined }) {
  const nameOf = usePersonName();
  return <>{nameOf(who)}</>;
}
